import React, {Fragment} from "react";
import {IonLoading} from "@ionic/react";
import {Alert, IconButton, Snackbar, Tooltip} from "@mui/material";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import SynchronizationService, {RequestStatus} from "../../../services/storage/distantStorage/SynchronizationService";
import './SynchronizeButton.css';
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    synchronizeColor?: 'inherit' | 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 20/06/2022
 * @last_update 20/06/2022
 **/
class SynchronizeButton extends React.Component<Props> {

    state = {
        isLoadingOpen: false,
        isToastOpen: false,
        isError: false,
        isWarning: false
    }

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        const onSynchronizeClick = () => {
            this.setState({isLoadingOpen: true});
            SynchronizationService.synchronizeOperationData()
                .then((result: RequestStatus) => {
                    switch (result) {
                        case RequestStatus.ALL_GOOD:
                            this.setState({isToastOpen: true});
                            break;
                        case RequestStatus.HALF_GOOD:
                            this.setState({isWarning: true});
                            break;
                        default:
                            this.setState({isError: true});
                            break;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({isError: true});
                })
                .finally(() => {
                    this.setState({isLoadingOpen: false});
                    if(!this.state.isError) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    }
                })
            ;
        }

        return (

            <Fragment>
                <Tooltip title={getTranslation("utils.button.synchronize.tooltip-title")}>
                    <IconButton onClick={onSynchronizeClick} size="small" color={this.props.synchronizeColor} slot="end">
                        <CloudSyncIcon/>
                    </IconButton>
                </Tooltip>
                <IonLoading
                    isOpen={this.state.isLoadingOpen}
                    onDidDismiss={() => {this.setState({isLoadingOpen: false})}}
                    message={getTranslation("utils.loading.message")}
                    spinner={'bubbles'}
                />
                <Snackbar
                    open={this.state.isToastOpen}
                    autoHideDuration={6000}
                    onClose={() => {
                        this.setState({isToastOpen: false})
                    }}
                    className="synchronize-button-alert"
                    anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                >
                    <Alert onClose={() => {this.setState({isToastOpen: false})}} severity="success" sx={{ width: '100%' }}>
                        {getTranslation("utils.button.synchronize.toast.success")}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={this.state.isError}
                    autoHideDuration={6000000}
                    onClose={() => {
                        this.setState({isError: false})
                    }}
                    className="synchronize-button-alert"
                    anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                >
                    <Alert onClose={() => {this.setState({isError: false})}} severity="error" sx={{ width: '100%'}}>
                        {getTranslation("utils.button.synchronize.toast.error")}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={this.state.isWarning}
                    autoHideDuration={6000}
                    onClose={() => {
                        this.setState({isWarning: false})
                    }}
                    className="synchronize-button-alert"
                    anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                >
                    <Alert onClose={() => {this.setState({isWarning: false})}} severity="warning" sx={{ width: '100%' }}>
                        {getTranslation("utils.button.synchronize.toast.warning")}
                    </Alert>
                </Snackbar>
            </Fragment>

        );

    };

}

export default withTranslation()(SynchronizeButton);
